module.exports = __webpack_public_path__ + "img/icons8_google_play_music.c314a89d.svg";